import React, {Component} from 'react';
import * as Elements from '../elements/header';
import * as DecoratedComponents from './HOC/HOCDecoratedComponents';

export default class ProfileHeader extends Component {
    constructor() {
        super();
        this.state = {
            isOpen: false,
        };
    };

    render() {
        const {
                visibility, picture, name, headline, industries, starRating, industriesDropDownList,
                locations, customUrl, permissions, ui, forms
            } = this.props,
            {guestMode} = ui;

        industries.industries = industriesDropDownList;

        const image = '/images/pattern3.jpg';
  
        return (
            <div id="header" className="profile-header">
                <div className="image" style={{backgroundImage: `url(${image})`}}></div>
                <div className="container profile-header-content">
                    <div className="row">
                        <div className="col-12 profile-header-picture">
                            <Elements.Picture { ...picture } { ...ui } />
                            {/*show when not in guestMode*/}
                            { (!guestMode && !forms.editing) && <div>
                                {/* <a className="btn-inline-icon" type="button"
                                   onClick={() => this.setState({isOpen: true}) }>
                                   <div className="share-icon"><Ionicon icon="ion-android-share-alt"/></div>
                                </a> */}
                                {/* <UI.ShareModal
                                    isOpen={ this.state.isOpen }
                                    url={ customUrl['1'] }
                                    onClose={ () => this.setState({isOpen: false}) }
                                    visibility={this.props.visibility}
                                    summary={this.props.summary}
                                    experience={this.props.experience}
                                /> */}
                            </div> }
                        </div>
                        <div className="col-12 profile-header-name">
                            <Elements.Name { ...name } customUrl={ customUrl }/>
                        </div>
                        <div className="col-xs-12 profile-header-stars">
                            <Elements.StarRating personId={permissions.personId}/>
                        </div>
                        <div className="col-12 profile-header-message">
                            <Elements.SideNav
                                { ...this.props }
                                visibility={visibility }
                                { ...ui }
                            />
                        </div>
                        <div className="col-12 profile-header-information">
                            <DecoratedComponents.Industry
                                componentData={ industries }
                                actionName='industriesApiCall'
                                { ...ui }
                            />
                        </div>
                        <div className="col-12 profile-header-information">
                            <DecoratedComponents.Location
                                componentData={ locations }
                                actionName='locationApiCall'
                                { ...ui }
                            />
                        </div>
                        <div className="col-12 profile-header-bio">
                            <h3 className="heading-three">Bio Summary Headline</h3>
                            <DecoratedComponents.Headline
                                componentData={ headline }
                                actionName='headlineApiCall'
                                {...ui }
                            />
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// src/client/components/site/features/profile/components/ProfileHeader.js